import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedeemBalanceComponent } from './redeem-balance.component';
import { SharedModule } from '../../../shared/shared.module';
import { MatButtonModule, MatProgressBarModule } from '@angular/material';
import { InvestmentsService } from '../investments.service';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatButtonModule,
		MatProgressBarModule
	],
	declarations: [
		RedeemBalanceComponent
	],
	exports: [
		RedeemBalanceComponent
	],
	providers: [
		InvestmentsService
	]
})
export class RedeemBalanceModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/redeem-balance/redeem-balance.module.ts